import styled from "styled-components";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-color: white;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    flex-shrink: unset;
    flex-grow: unset;
    height: 100%;
  }
`;

export const Content = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 96px;

  @media screen and (max-width: 1010px) {
    padding: 48px 40px;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto repeat(2, 279px);
  grid-column-gap: 88px;

  @media screen and (max-width: 1010px) {
    width: 100%;
    grid-template-columns: unset;
    grid-column-gap: unset;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansMedium};
  font-size: 33px;
  line-height: 61px;
  text-transform: uppercase;

  @media screen and (max-width: 1010px) {
    line-height: 40px;
    color: #6f57ff;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-size: 15px;
  line-height: 22px;

  p {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1010px) {
    margin-top: 48px;
  }
`;
